import React from 'react';
import { Die } from '../types';
import DieFace from './DieFace';

interface DiceDisplayProps {
  dice: Die[];
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const DiceDisplay: React.FC<DiceDisplayProps> = ({ dice, className = '', size = 'md' }) => {
  // Sort dice by value in ascending order
  const sortedDice = [...dice].sort((a, b) => a.value - b.value);

  return (
    <div className={`flex gap-2 flex-wrap ${className}`}>
      {sortedDice.map((die, idx) => (
        <DieFace key={idx} value={die.value} size={size} />
      ))}
    </div>
  );
};

export default DiceDisplay;
